import { render, staticRenderFns } from "./OrderQualification.vue?vue&type=template&id=6883c2ff&scoped=true"
import script from "./OrderQualification.vue?vue&type=script&lang=js"
export * from "./OrderQualification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883c2ff",
  null
  
)

export default component.exports